import DefaultRequest from "./DefaultRequest";
import UserRequestInterface from "./UserRequestInterface";

class UserRequest extends DefaultRequest implements UserRequestInterface {
    // ------- GET parameters ------
    public lang: string;
    public theme: string;
    public token: string;
    // --------------------

    protected errors: string[];

    constructor(obj: object) {
        super();
        this.theme = "light";
        this.lang = "en";
        this.token = '';

        this.errors = [];

        if (typeof obj !== 'undefined')
            this.fromObject(obj);
    }

    public validate(): boolean {
        const isValidTheme = !this.isEmpty(this.theme);
        const isValidLang = !this.isEmpty(this.lang);
        const isValidToken = !this.isEmpty(this.token);

        if (!isValidToken) this.errors.push("token");
        if (!isValidLang) this.errors.push("language");
        if (!isValidTheme) this.errors.push("theme");

        return isValidTheme && isValidToken && isValidLang;
    }

    public getErrors(): string[] {
        return this.errors;
    }

    public getName() {
        return 'UserRequest'
    }
}

export default UserRequest;
